var React = require('react');

function AlertWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.001 21c1.015 0 1.846-.83 1.846-1.846h-3.692c0 .923.831 1.846 1.846 1.846zm5.537-7.83v-2.942c0-2.61-1.513-4.796-4.153-5.374v-.578c0-.706-.618-1.276-1.384-1.276-.766 0-1.384.57-1.384 1.276v.578c-2.649.578-4.153 2.755-4.153 5.374v2.942l-1.19 1.097c-.582.536-.176 1.454.646 1.454h12.153c.822 0 1.237-.609.656-1.144l-1.19-1.407z","stroke":"#FFF","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

AlertWhite.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = AlertWhite;

AlertWhite.default = AlertWhite;
